const ICON_SIZE = 18;

const wrapSvg = (viewBox: string, inner: string): string =>
  `<svg xmlns="http://www.w3.org/2000/svg" width="${ICON_SIZE}" height="${ICON_SIZE}" viewBox="${viewBox}" aria-hidden="true" focusable="false">${inner}</svg>`;

export const CALENDAR_PROVIDER_ICONS: Record<string, string> = {
  google: wrapSvg(
    "0 0 48 48",
    `<path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303C33.654 32.657 29.083 36 24 36c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C33.64 6.053 28.991 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/><path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 16.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C33.64 6.053 28.991 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/><path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.067 0-9.417-3.122-11.283-7.532l-6.58 5.069C9.505 39.556 16.227 44 24 44z"/><path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>`,
  ),
  outlook: wrapSvg(
    "0 0 24 24",
    `<rect width="24" height="24" rx="4" fill="#0078D4"/><path fill="#fff" d="M6.5 7.5h11v9h-11z"/><path fill="#0078D4" d="M8 9.5h7v5H8z"/><path fill="#fff" d="M9.5 11h4v2h-4z"/>`,
  ),
  office365: wrapSvg(
    "0 0 24 24",
    `<rect width="10" height="10" x="1" y="1" fill="#F25022"/><rect width="10" height="10" x="13" y="1" fill="#7FBA00"/><rect width="10" height="10" x="1" y="13" fill="#00A4EF"/><rect width="10" height="10" x="13" y="13" fill="#FFB900"/>`,
  ),
  yahoo: wrapSvg(
    "0 0 24 24",
    `<rect width="24" height="24" rx="4" fill="#6001D2"/><path fill="#fff" d="M7.2 7.5h2.4l2.1 5.2L13.8 7.5h2.3l-3.4 9h-2.4L7.2 7.5zm7.8 0H17v9h-2V7.5z"/>`,
  ),
  apple: wrapSvg(
    "0 0 24 24",
    `<path fill="#111827" d="M16.24 12.74c.02-2.53 2.06-3.74 2.15-3.8-1.17-1.71-2.99-1.95-3.63-1.98-1.55-.16-3.03.91-3.82.91-.8 0-2.02-.89-3.32-.86-1.71.03-3.28 1-4.16 2.54-1.77 3.07-.45 7.62 1.27 10.11.84 1.22 1.84 2.58 3.16 2.53 1.27-.05 1.75-.82 3.29-.82 1.54 0 1.97.82 3.31.79 1.37-.02 2.23-1.24 3.06-2.47.96-1.41 1.36-2.77 1.38-2.84-.03-.01-2.65-1.02-2.68-4.2zM14.67 4.86c.7-.85 1.17-2.03 1.04-3.21-1.01.04-2.23.67-2.96 1.52-.65.75-1.22 1.95-1.07 3.1 1.13.09 2.28-.57 2.99-1.41z"/>`,
  ),
};

export function createCalendarProviderIcon(optionId: string): HTMLElement | null {
  const markup = CALENDAR_PROVIDER_ICONS[optionId];
  if (!markup) {
    return null;
  }

  const wrapper = document.createElement("span");
  wrapper.style.cssText =
    "display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;flex-shrink:0;";
  wrapper.innerHTML = markup;
  return wrapper;
}
